module.exports = __webpack_public_path__ + "img/leftcalf-mesomorph-female.5bd747aa.svg";